import { useEffect, useState } from 'react'

export const usePostMessage = (
  requestMessageId: string,
  expectedResponseId: string,
) => {
  const [data, setData] = useState<any>(null)
  const [received, setReceived] = useState(false)

  useEffect(() => {
    const { referrer } = document
    if (!referrer) return

    const handleMessage = (event: MessageEvent) => {
      if (event.data?.id === expectedResponseId) {
        setData(event.data)
        setReceived(true)
      }
    }

    window.addEventListener('message', handleMessage)
    window.parent.postMessage({ id: requestMessageId }, referrer)
    // eslint-disable-next-line
    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [requestMessageId, expectedResponseId])

  return { data, received }
}
